import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Home, CreditCard, Plus, TrendingUp, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigation } from "@/hooks/use-navigation";
import { WalletTopUpDialog } from "./wallet-topup-dialog";
import { Link } from "wouter";
import { cn } from "@/lib/utils";

export function CustomerBottomNav() {
  const { isActive, showBottomNav } = useNavigation();
  const [showTopUpDialog, setShowTopUpDialog] = useState(false);

  const navItems = [
    { icon: Home, label: "Home", href: "/portal/home" },
    { icon: CreditCard, label: "Cards", href: "/portal/cards" },
    { icon: Plus, label: "Top Up", action: () => setShowTopUpDialog(true), isAction: true },
    { icon: TrendingUp, label: "Activity", href: "/portal/transactions" },
    { icon: User, label: "Account", href: "/portal/account" },
  ];

  return (
    <>
      <AnimatePresence>
        {showBottomNav && (
          <motion.nav
            initial={{ y: 100 }}
            animate={{ y: 0 }}
            exit={{ y: 100 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background/95 backdrop-blur-lg border-t"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
          >
            <div className="flex items-center justify-around h-16 px-2">
              {navItems.map((item) => {
                const active = item.href ? isActive(item.href) : false;
                
                if (item.isAction) {
                  return (
                    <Button
                      key={item.label}
                      variant="ghost"
                      size="sm"
                      onClick={item.action}
                      className={cn(
                        "flex flex-col items-center justify-center gap-1 h-14 w-14 rounded-xl transition-all",
                        "bg-primary text-primary-foreground hover:bg-primary/90"
                      )}
                    >
                      <item.icon className="h-6 w-6" />
                    </Button>
                  );
                }

                return (
                  <Link key={item.label} href={item.href!}>
                    <Button
                      variant="ghost"
                      size="sm"
                      className={cn(
                        "flex flex-col items-center justify-center gap-1 h-14 min-w-[64px] rounded-xl transition-all",
                        active && "bg-primary/10 text-primary"
                      )}
                    >
                      <item.icon className={cn("h-5 w-5", active && "scale-110")} />
                      <span className={cn("text-[10px] font-medium", active && "font-semibold")}>
                        {item.label}
                      </span>
                    </Button>
                  </Link>
                );
              })}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>

      <WalletTopUpDialog
        open={showTopUpDialog}
        onOpenChange={setShowTopUpDialog}
      />
    </>
  );
}
